import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { VeilleReglementaireParams, VeilleReglementaireResponse } from "./types";

async function runVeilleReglementaire(
  params: VeilleReglementaireParams
): Promise<VeilleReglementaireResponse> {
  const response = await fetchClient<VeilleReglementaireResponse>(
    "/core/media-scout/run_reglementaire/",
    { method: "POST", body: params }
  );

  if (response.error || !response.data) {
    const detail =
      response.error?.detail ??
      response.error?.message ??
      "Erreur lors de l'exécution de la veille réglementaire.";
    throw new Error(detail);
  }

  if (response.data.status === "error") {
    throw new Error("Erreur lors de l'exécution de la veille réglementaire.");
  }

  return response.data;
}

export function useRunVeilleReglementaire() {
  return useMutation<VeilleReglementaireResponse, Error, VeilleReglementaireParams>({
    mutationFn: runVeilleReglementaire,
  });
}
